// tslint:disable-next-line
export const HttpStatusCodeConstants = {
  forbidden: 403,
  internalServerError: 500,
  ok: 200,
  unauthorized: 401,
};
